import UIDs from "../../../../UIDs";

const uid = UIDs.screens.me.withdraw;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    SEND_VERIFY_CODE_ASYNC: `${uid}.sendVerifyCodeAsync`,
    SEND_VERIFY_CODE_SUCCESS: `${uid}.sendVerifyCodeSuccess`,
    SEND_VERIFY_CODE_FAILURE: `${uid}.sendVerifyCodeFailure`,
    VERIFY_CODE_ASYNC: `${uid}.verifyCodeAsync`,
    VERIFY_CODE_SUCCESS: `${uid}.verifyCodeSuccess`,
    VERIFY_CODE_FAILURE: `${uid}.verifyCodeFailure`,
    SAVE_WITHDRAWAL_ASYNC: `${uid}.saveWithdrawalAsync`,
    SAVE_WITHDRAWAL_SUCCESS: `${uid}.saveWithdrawalSuccess`,
    SAVE_WITHDRAWAL_FAILURE:`${uid}.saveWithdrawalFailure`,
    SET_STATE: `${uid}.setState`
};

export { ActionTypes };